// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".EmptyComponent__EmptyComponent___1dg1K{align-items:center;-webkit-box-align:center;-webkit-box-pack:center;display:flex;-ms-flex-align:center;-ms-flex-pack:center;height:100%;justify-content:center;min-width:100%;position:relative;scroll-snap-align:start;width:100%}.EmptyComponent__innerDiv___31s73{background:#fff;display:flex;flex-direction:column}", ""]);
// Exports
exports.locals = {
	"EmptyComponent": "EmptyComponent__EmptyComponent___1dg1K",
	"innerDiv": "EmptyComponent__innerDiv___31s73"
};
module.exports = exports;
